import "./../../css/components/btntotop";

export function btntotop() {
  $(document).on("scroll", function (event) {
    if ($(window).scrollTop() <= 100) {
      $("#btntotop").removeClass("enabled");
    } else {
      if ($("#btntotop").not("enabled")) {
        $("#btntotop").addClass("enabled");
      }
    }
  });

  $("body").on("click", "#btntotop", function (event) {
    event.preventDefault();
    $("html,body").animate({ scrollTop: 0 }, "fast");
  });
}